import { render, staticRenderFns } from "./points_task_electric.vue?vue&type=template&id=c83e885e&scoped=true"
import script from "./points_task_electric.vue?vue&type=script&lang=js"
export * from "./points_task_electric.vue?vue&type=script&lang=js"
import style0 from "./points_task_electric.vue?vue&type=style&index=0&id=c83e885e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83e885e",
  null
  
)

export default component.exports